import script from "./UserDetailsTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDetailsTab.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__